export namespace INotification {
  export interface INoticeData {
    title: string;
    message: string;
    status: NoticeStatus;
  }

  export enum NoticeStatus {
    Success = 'success',
    Warning = 'warning',
    Error = 'error',
  }

  export enum RouteKey {
    Notice = 'notice',
  }
}